import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
class TicketModalOriginDemand extends Vue {

  @Prop({ default: 'call', required: true, type: [String] })
  value: 'call' | 'mail'

  @Prop({ default: false, required: true, type: [Boolean] })
  disabled: boolean;

  dtKindsOfDemand: { key: string, value: string, icon: string }[];

  /**
   *
   */
  constructor() {
    super();
    this.dtKindsOfDemand = [
      { key: 'call', value: 'call', icon: 'icon-phone' },
      // { key: 'sms', value: 'sms' },
      // { key: 'mobile_app', value: 'mobile_app' },
      { key: 'mail', value: 'mail', icon: 'icon-mail' },
      // { key: 'web_app', value: 'web_app' },
      { key: 'team', value: 'team',icon: 'supervisor_account' },
    ]
  }
  get vModel(): 'call' | 'mail' { return this.value };
  set vModel(val: 'call' | 'mail') { this.$emit('input', val) }

  handleClick(value: 'call' | 'mail') {
    this.vModel = value;
  }
}

export default TicketModalOriginDemand;


// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-modal-origin-demand/index.ts